import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=3993baa9&scoped=true"
import script from "./LockIcon.vue?vue&type=script&lang=js"
export * from "./LockIcon.vue?vue&type=script&lang=js"
import style0 from "./LockIcon.vue?vue&type=style&index=0&id=3993baa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993baa9",
  null
  
)

export default component.exports